import { createApp } from "vue";
import vClickOutside from "click-outside-vue3";
import { VTooltip } from "floating-vue";
import "floating-vue/dist/style.css";

import App from "./App.vue";
import router from "@/router";
import store from "@/store";

import "@/shared/css/index.css";

import language from "@/plugins/language";
import { i18n } from "@/i18n";
import { windowService } from "@/shared/connection/window.service";
import { createPinia } from "pinia";

const pinia = createPinia();

createApp(App)
    .use(store)
    .use(pinia)
    .use(router)
    .use(i18n)
    .use(language)
    .use(vClickOutside)
    .directive("tooltip", VTooltip)
    .mount("#app");

if (!windowService.isInIFrame()) {
    import("@/shared/consola").then(({ makeLogger, settledLogLevel }) => {
        const { VUE_APP_VERSION, VUE_APP_BUILD_NO = 1 } = process.env || {};
        makeLogger("easytools").info(
            `v_${VUE_APP_VERSION}(b#${VUE_APP_BUILD_NO})[lv.${settledLogLevel}]`
        );
    });
}
